module.exports = __webpack_public_path__ + "img/linen-farm.67427acd.webp";